<template>
  <div class="Trio-header">
    <hgroup class="Trio-title-group">
      <h1 class="Trio-main-title">{{ header.funnel.title }}</h1>
      <h2 class="Trio-subtitle">{{ header.funnel.desc }}</h2>
    </hgroup>
    <div v-if="step !== totalSteps.funnel" class="Trio-step-bar">
      <a href="#" @click="previousStep" class="Trio-btn-back"
        ><i class="icon-arrow-back"></i
        ><span class="Trio-text-hidden">Atrás</span></a
      >
      <div class="Trio-step-box">
        <span class="Trio-text">{{ step }} / {{ totalSteps.funnel }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "../store/index.js";

export default {
  name: "funnelHeader",
  computed: {
    header() {
      return Store.getters["ui/header"];
    },
    step() {
      return Store.getters["ui/step"];
    },
    totalSteps() {
      return Store.getters["ui/totalSteps"];
    },
  },
  methods: {
    previousStep() {
      let step = Store.getters["ui/step"];
      step = step - 1;
      if (step == 0) Store.commit("ui/CLEAR_ALL");
      else Store.commit("ui/SET_STEP", step);
    },
  },
};
</script>
